import { Injectable } from '@angular/core';

import { IDistrictsApiClient } from './i-districts-api.client';
import { DistrictsApiClient } from './districts-api.client';
import { DistrictsInMemoryApiClient } from './districts.api.inmemory.client';
import { ApiClientProvider } from '../../../data-access';

@Injectable({
  providedIn: 'root'
})
export class DistrictsApiClientProvider extends ApiClientProvider<IDistrictsApiClient> {
  constructor(
    private client: DistrictsApiClient,
    private inMemoryClient: DistrictsInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IDistrictsApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IDistrictsApiClient {
    return this.client;
  }
}
